import React, { useEffect } from 'react';
import { MembershipCostComparisonContent } from './MembershipCostComparisonContent';
import './MembershipCostComparisonModal.css';

interface MembershipCostComparisonModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const MembershipCostComparisonModal: React.FC<MembershipCostComparisonModalProps> = ({
  isOpen,
  onClose,
}) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="membership-cost-modal__backdrop"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="membership-cost-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="membership-cost-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="membership-cost-modal__close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <MembershipCostComparisonContent headingLevel="h2" />
      </div>
    </div>
  );
};
